<template>
  <v-layout @focus.capture="updateFocus($event)" @dblclick="doubleClick($event)" @change="updateInput($event)" @contextmenu.prevent="showContextMenu" ref="data-container" style="position: relative; height: 100%; width: 100%;">
    <v-menu v-if="isTenantAdmin" v-model="contextMenu.show" :position-x="contextMenu.x" :position-y="contextMenu.y" absolute offset-y>
      <v-list dense>
        <template v-for="(item, index) in contextMenu.items">
          <v-divider v-if="item.divider" :key="`divider-${index}`" />
          <v-list-tile v-else :key="`contextMenu-${index}`" :disabled="item.disabled" @click="contextMenuAction(item)">
            <v-list-tile-avatar v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </template>
      </v-list>
    </v-menu>
    <v-flex>
      <div class="rowHeaderCollection">
        <VirtualCollection ref="rowHeaderCollection" v-if="isInitialized" :cellSizeAndPositionGetter="rowHeaderSizeAndPositionGetter" :collection="rowHeaders" :height="containerHeight" :width="WIDTH_PADDING">
          <div class="rowHeader unselectable" :id="`rowHeader-${props.data.value}`" :class="isSelectedRowHeader(props.data.value, selectedLocation)" slot="cell" slot-scope="props">
            {{ props.data.text }}
          </div>
        </VirtualCollection>
      </div>
    </v-flex>
    <v-flex>
      <div class="columnHeaderCollection">
        <div ref="scrollCover" class="scroll-cover" />
        <VirtualCollection ref="columnHeaderCollection" v-if="isInitialized" :cellSizeAndPositionGetter="columnHeaderSizeAndPositionGetter" :collection="columnHeaders" :height="HEIGHT_PADDING" :width="containerWidth">
          <div class="columnHeader unselectable" :id="`columnHeader-${props.data.value}`" :class="isSelectedColumnHeader(props.data.value, selectedLocation)" slot="cell" slot-scope="props">{{ props.data.text }}</div>
        </VirtualCollection>
      </div>
      <VirtualCollection ref="cellCollection" v-if="isInitialized" :cellSizeAndPositionGetter="cellSizeAndPositionGetter" :collection="data" :height="containerHeight" :width="containerWidth">
        <div slot="cell" slot-scope="props" class="cell lighten-2" :class="[getMainClass(props.data.location, updatedToggle), isDirty(props.data) ? 'dirty' : '', isDeletedClass(props.data.location) ? 'deleted' : '']">
          <input :id="`cell-${props.data.location}`" :class="[isSelectedCell(props.data.location, selectedLocation)]" v-model.lazy="props.data.value" />
          <v-icon v-for="(sideClass, index) in getSideClasses(props.data.location, updatedToggle)" :key="`sideClass-${index}`" class="bubble" :style="getBubblePadding(index)" :color="`${sideClass} lighten-2`">brightness_1</v-icon>
        </div>
      </VirtualCollection>
    </v-flex>
  </v-layout>
</template>

<script>
  import {
    getScrollbarSize,
    ROW_HEIGHT,
    getCellIndex,
    getCellInput,
  } from './Table'

  const HEIGHT_PADDING = 25
  const WIDTH_PADDING = 40

  const normalizeContainer = (val) => val >= 0 ? val : 0

  import { createNamespacedHelpers } from 'vuex'
  const app = createNamespacedHelpers('app')
  const authenticate = createNamespacedHelpers('authenticate')


  export default {
    inject: ['helper'],
    props: {
      data: Array,
      rowHeaders: Array,
      columnHeaders: Array,
      heightPadding: {
        type: Number,
        default: 0,
      },
      widthPadding: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        HEIGHT_PADDING,
        WIDTH_PADDING,
        containerHeight: 0,
        containerWidth: 0,
        updatedToggle: false,
        isInitialized: false,
        showTable: false,
        dom: {
          rowHeader: null,
          columnHeader: null,
          cellInput: null,
        },
        cells: {
          mainClass: {},
          sideClass: {},
        },
        contextMenu: {
          target: null,
          show: false,
          x: 0,
          y: 0,
          items: [],
        },
        resizeObserver: null,
      }
    },
    computed: {
      ...authenticate.mapGetters(['isTenantAdmin']),
      showLogs() {
        return this.$store.getters['reviewingestionresults/showLogs']
      },
      logs() {
        return this.$store.getters['reviewingestionresults/groupedLogs']
      },
      selectedLocation: {
        get() {
          return this.$store.getters['reviewingestionresults/selectedLocation']
        },
        set(value) {
          this.$store.dispatch('reviewingestionresults/setSelectedLocation', value)
        },
      },
      resetDirtyDatum() {
        return this.$store.getters['reviewingestionresults/resetDirtyDatum']
      },
      locator: {
        get() {
          return this.$store.getters['reviewingestionresults/locator']
        },
        set(value) {
          this.$store.dispatch('reviewingestionresults/setLocatorExpression', value)
        },
      },
      dirtyData() {
        return this.$store.getters['reviewingestionresults/dirtyData']
      },
      locationPrinter: {
        get() {
          return this.$store.getters['reviewingestionresults/locationPrinter']
        },
        set(value) {
          this.$store.dispatch('reviewingestionresults/setLocationPrinterExpression', value)
        },
      },
      metadata() {
        return this.$store.getters['reviewingestionresults/getMetadata']()
      },
    },
    watch: {
      resetDirtyDatum(locations) {
        locations.forEach(location => {
          let cell = this.locator(location)
          cell.value = cell.initialValue
          this.updateLogClasses(cell.location)
        })
      },
      async isInitialized(value) {
        if (!value) {
          return
        }

        await this.$nextTick()

        let cellCollection = this.$refs['cellCollection']
        let columnHeader = this.$refs['columnHeaderCollection']
        let rowHeader = this.$refs['rowHeaderCollection']

        let { scrollbarWidth, scrollbarHeight } = getScrollbarSize()

        this.$refs.scrollCover.style.setProperty('width', `${scrollbarWidth}px`, 'important')

        cellCollection.$refs.outer.onscroll = function() {
          columnHeader.$refs.outer.scrollLeft = this.scrollLeft
          rowHeader.$refs.outer.scrollTop = this.scrollTop
        }

        rowHeader.$refs.outer.style.paddingBottom = `${scrollbarHeight}px`
        columnHeader.$refs.outer.style.paddingRight = `${scrollbarWidth}px`

      },
      showLogs() {
        this.updateAllLogClasses()
      },
    },
    methods: {
      ...app.mapActions(['setSnackbar']),
      isDeletedClass(location) {
        let metadatum = this.helper.getCellMetadatum(location, this.metadata)
        return metadatum && metadatum.isDeleted
      },
      triggerUpdate() {
        this.selectedLocation = null
      },
      contextMenuAction(item) {
        if (this.contextMenu.target.nodeName == 'INPUT') {
          if (item.action == 'resetChanges') {
            let cellIndex = getCellIndex(this.contextMenu.target.id)
            this.resetChanges(cellIndex)
            return
          }
        }

        this.helper[item.action]({
          locationId: this.contextMenu.target.id,
        })
      },
      resetChanges(location) {
        this.$store.dispatch('reviewingestionresults/resetDirtyDatum', [location])
      },
      async showContextMenu(event) {
        let target = event.target
        while (!target.id && target.parentNode) {
          target = target.parentNode
        }

        this.contextMenu.target = target
        this.contextMenu.show = false
        this.contextMenu.x = event.clientX
        this.contextMenu.y = event.clientY

        let contextName = this.helper.getContextName(target.id)
        let location = getCellIndex(target.id)
        this.contextMenu.items = this.helper.getContextItems(contextName, location)
        await this.$nextTick()
        this.contextMenu.show = true
      },
      getBubblePadding(index) {
        return `padding-top: ${10 * index || 0}px;`
      },
      getMainClass(location) {
        return this.cells.mainClass[location]
      },
      getSideClasses(location) {
        return this.cells.sideClass[location]
      },
      doubleClick(event) {
        if (event.target.nodeName == 'INPUT') {
          let location = getCellIndex(event.target.id)
          this.$store.dispatch('reviewingestionresults/setFocusLocation', location)
        }
      },
      updateFocus(event) {
        if (event.target.nodeName == 'INPUT') {
          let location = getCellIndex(event.target.id)
          this.selectCell(location, event.target)
        }
      },
      updateInput(event) {
        let location = getCellIndex(event.target.id)
        this.updateLogClasses(location)
      },
      isSelectedColumnHeader(index, selectedLocation) {
        let columnIndex = this.helper.getLocationColumn(selectedLocation)
        let result = columnIndex == index ? 'column-selected' : ''
        return result
      },
      isSelectedRowHeader(index, selectedLocation) {
        let rowIndex = this.helper.getLocationRow(selectedLocation)
        let result = rowIndex == index ? 'row-selected' : ''
        return result
      },
      isSelectedCell(location, selectedLocation) {
        let result = selectedLocation == location ? 'cell-selected' : ''
        return result
      },
      rowHeaderSizeAndPositionGetter(item, index) {
        const width = WIDTH_PADDING
        let y = index * ROW_HEIGHT

        return {
          width: width,
          height: ROW_HEIGHT,
          x: 0,
          y: y,
        }
      },
      columnHeaderSizeAndPositionGetter(item, index) {
        const height = 23
        const columnIndex = index % this.helper.getMaxWidth()
        const y = 0

        return {
          width: this.helper.getDataLengths(columnIndex),
          height: height,
          x: this.helper.getColumnLength(columnIndex),
          y: y,
        }
      },
      cellSizeAndPositionGetter(item, index) {
        const columnIndex = index % this.helper.getMaxWidth()

        const y = parseInt(index / this.helper.getMaxWidth()) * ROW_HEIGHT

        let size = {
          width: this.helper.getDataLengths(columnIndex),
          height: ROW_HEIGHT,
          x: this.helper.getColumnLength(columnIndex),
          y: y,
        }

        return size
      },
      async selectCell(location, element) {
        this.selectedLocation = location

        if (element) {
          this.dom.cellInput = element
        } else if (location) {
          this.dom.cellInput = getCellInput(location)
        }

        await this.$nextTick()
        this.dom.cellInput.focus()
      },
      async initialize() {
        this.locationPrinter = this.helper.locationPrinter()
        this.locator = this.helper.locator()
        this.updateAllLogClasses()
        await this.$nextTick()
        this.isInitialized = true
      },
      initializeLogClasses(location) {
        let classes = this.getLogClasses(location)
        if (classes.length > 0) {
          this.$set(this.cells.mainClass, location, classes[0])
          this.$set(this.cells.sideClass, location, classes.slice(1))
        }
      },
      updateAllLogClasses() {
        for (const [location] of Object.entries(this.logs)) {
          this.updateLogClasses(location)
        }
      },
      // Updates the css of a cell
      updateLogClasses(location) {
        let classes = this.getLogClasses(location)
        let cell = this.locator(location)
        if (this.isDirty(cell)) {
          this.$store.dispatch('reviewingestionresults/updateDirtyData', [cell.location, cell.value])
        } else {
          this.$store.dispatch('reviewingestionresults/updateDirtyData', [cell.location, null])
        }

        if (classes.length == 0) {
          this.$delete(this.cells.mainClass, location)
          this.$delete(this.cells.sideClass, location)
          return
        }

        if (this.isDirty(cell) || this.isDeletedClass(location)) {
          this.$delete(this.cells.mainClass, location)
          this.$set(this.cells.sideClass, location, classes)
        } else if (classes.length > 0) {
          this.$set(this.cells.mainClass, location, classes[0])
          this.$set(this.cells.sideClass, location, classes.slice(1))
        }
      },
      async scrollIntoCenter(location) {
        let rowIndex = this.helper.getLocationRow(location)
        let columnIndex = this.helper.getLocationColumn(location)

        let outer = this.$refs.cellCollection.$refs.outer

        let offset = 3

        let x = this.helper.getColumnLength(columnIndex - offset)
        let y = (rowIndex - offset) * ROW_HEIGHT

        let callback = () => this.selectCell(location)
        const isThere = () =>
          (Math.abs(outer.scrollTop - y) < 2 || (outer.scrollTop == 0 && y < 0)) && (Math.abs(outer.scrollLeft - x) < 2 || (outer.scrollLeft == 0 && x < 0))

        const onScroll = function() {
          if (isThere()) {
            outer.removeEventListener('scroll', onScroll)
            requestAnimationFrame(() => callback())
          }
        }

        outer.addEventListener('scroll', onScroll)

        await this.$nextTick()
        outer.scrollTo({ left: x, top: y, behavior: 'smooth' })

        if (isThere()) {
          new Promise((resolve) => {
            setTimeout(() => {
              resolve()
            }, 100)
          })
            .then(() => {
              requestAnimationFrame(() => callback())
            })
        }
      },
      isDirty(datum) {
        return datum && datum.value != datum.initialValue
      },
      getLogClasses(location) {
        let locationLogs = this.getLogs(location)
        let locationLogColors = this.getLogColors(locationLogs)
        return locationLogColors
      },
      getLogs(location) {
        return this.logs[location]
      },
      getLogColors(logs) {
        let result = []

        if (!logs) {
          return result
        }

        let severities = {}
        logs.forEach(error => severities[error.severity] = true)

        if (severities.error && this.showLogs['error']) {
          result.push('error')
        }
        if (severities.warning && this.showLogs['warning']) {
          result.push('warning')
        }
        if (severities.info && this.showLogs['info']) {
          result.push('info')
        }

        return result
      },
    },
    async mounted() {
      await this.$nextTick()
      let totalHeightPadding = (HEIGHT_PADDING + this.heightPadding)
      let totalWidthPadding = (WIDTH_PADDING + this.widthPadding)

      let dataContainer = this.$refs['data-container']
      this.containerHeight = normalizeContainer(dataContainer.clientHeight - (totalHeightPadding))
      this.containerWidth = normalizeContainer(dataContainer.clientWidth - (totalWidthPadding))
      
      /* eslint-disable */
      if (ResizeObserver) {
        this.resizeObserver = new ResizeObserver(() => {
          this.containerHeight = normalizeContainer(dataContainer.clientHeight - (totalHeightPadding))
          this.containerWidth = normalizeContainer(dataContainer.clientWidth - (totalWidthPadding))
          this.containerHeight = normalizeContainer(dataContainer.clientHeight - (totalHeightPadding))
          this.containerWidth = normalizeContainer(dataContainer.clientWidth - (totalWidthPadding))
        })
        this.resizeObserver.observe(dataContainer)
      /* eslint-enable */
      } else {
        window.addEventListener('resize', () => {
          this.containerHeight = normalizeContainer(dataContainer.clientHeight - (totalHeightPadding))
          this.containerWidth = normalizeContainer(dataContainer.clientWidth - (totalWidthPadding))
        })
      }
    },
    beforeDestroy() {
      this.resizeObserver.disconnect()
    },
  }
</script>

<style>
  .scroll-cover {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: #f3f3f3;
  }

  .columnHeaderCollection .vue-virtual-collection {
    overflow-x: hidden;
    overflow-y: scroll;
  }

  .rowHeaderCollection .vue-virtual-collection {
    overflow: hidden;
  }

  .columnHeaderCollection {
    background-color: #f3f3f3;
    position: relative;
  }

  .rowHeaderCollection {
    padding-top: 23px;
    background-color: #f3f3f3;
  }
</style>

<style scoped>
  .cell-container input,
  .cell-container div {
    width: 100%;
    height: 100%;
  }

  .columnHeader {
    padding-top: 2px;
    border-right-color: transparent !important;
    border-top-color: transparent !important;
  }

  .rowHeader {
    padding-top: 10px;
    position: relative;
    border-bottom-color: transparent !important;
    border-left-color: transparent !important;
  }

  .columnHeader,
  .rowHeader {
    border: 1px solid #bbb;
    text-align: center;
    font-size: 13px;
  }

  .column-selected {
    border-bottom-color: teal;
  }

  .row-selected {
    border-right-color: teal;
  }

  .column-selected,
  .row-selected {
    color: teal;
    font-weight: bold;
    background-color: #e0e0e0;
  }

  .rowHeaderMetadata {
    position: absolute;
    bottom: -6px;
    height: auto !important;
    display: flex;
    font-weight: 600;
  }

  .removedRow {
    color: #f75b4a;
    font-size: 1.3rem;
  }

  .newRow {
    color: #2196f3;
    margin-top: 4px;
  }

  .cell {
    position: relative;
  }

  .dirty {
    font-weight: 500;
    color: teal;
  }

  .dirty.deleted {
    color: hsl(180, 65%, 25%);
  }

  .deleted {
    background-color: #eeeeee;
    color: #555;
  }

  .cell>input {
    width: 100%;
    height: 100%;
    padding: 5px 20px 5px 5px;
    margin: 0px 1px 1px 0px;
    border: 1px solid #ddd;
    border-right-color: transparent;
    border-top-color: transparent;
    outline-color: transparent;
    outline-offset: -2px;
    outline-width: 10px;
    outline-style: auto;
  }

  input.cell-selected {
    outline-color: teal;
    outline-offset: -2px;
    outline-width: 2px;
    outline-style: solid;
  }

  .bubble {
    position: absolute;
    top: 5px;
    right: 5px;
    font-size: 10px !important;
  }
</style>
